import styled from "styled-components";

export const PaginaAviso = styled.div`
    position: relative;
    width: 210mm;
    height: 297mm;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border: 1px solid #e0e0e0;
    box-sizing: border-box;
    padding-top: 40px;
    page-break-inside: avoid;

    div.PaginaAviso__mensagem {
        box-sizing: border-box;
        padding: 0 50px;
        text-align: justify;
        display: flex;
        flex-direction: column;
        align-items: center;

        p {
            font-size: 15.5px;
        }
        
    }

    img.PaginaAviso__logo {
        position: absolute;
        height: 80px;
        right: 50px;
        bottom: 30px;
        object-fit: contain;
    }

`;